import {
  Box,
  Popover,
  type PopoverTargetProps,
} from '@mantine/core'
import { useMouse, useViewportSize } from '@mantine/hooks'
import { useContext } from 'react'

import { type PopoverPosition, PopoverTrackedContext } from './PopoverTrackedContext'

export * from './usePopoverTrackedState'

export type PopoverTrackedTargetParams = PopoverTargetProps

export function PopoverTrackedTarget({
  children,
  ...props
}: PopoverTrackedTargetParams) {
  const { x, y } = useMouse()

  const { height: vpHeight, width: vpWidth } = useViewportSize()

  const { height, width, handleClose, handleMove } = useContext(PopoverTrackedContext)

  return (
    <Popover.Target {...props}>
      <Box
        onMouseLeave={() => {
          handleMove.clear()
          handleClose.start()
        }}
        onMouseMoveCapture={() => {
          handleClose.start()

          if (x && y) {
            const shouldPositionRight = x + width > vpWidth
            const shouldPositionBottom = y + height > vpHeight

            const position: PopoverPosition = {
              bottom: shouldPositionBottom ? 0 : undefined,
              left: shouldPositionRight ? undefined : x,
              right: shouldPositionRight ? 0 : undefined,
              top: shouldPositionBottom ? undefined : y + 5,
            }

            handleMove.clear()
            handleMove.start(position)
          }
        }}
      >
        {children}
      </Box>
    </Popover.Target>
  )
}
